import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_full_screen",
  "use": "icon-ic_full_screen-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ic_full_screen\">\n<path d=\"M13.9999 2C14.3681 2 14.6666 2.29848 14.6666 2.66667V13.3333C14.6666 13.7015 14.3681 14 13.9999 14H1.99992C1.63173 14 1.33325 13.7015 1.33325 13.3333V2.66667C1.33325 2.29848 1.63173 2 1.99992 2H13.9999ZM13.3333 3.33333H2.66659V12.6667H13.3333V3.33333ZM8.66659 11.3333V10H10.6666V8H11.9999V11.3333H8.66659ZM7.33325 4.66667V6H5.33325V8H3.99992V4.66667H7.33325Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol